import CustomInput from "components/CustomInput";
import { Form, Formik } from "formik";

const BasicInfo = ({ onContinue }) => {
  const initialValues = {
    dateOfBirth: "",
    allergies: "",
    isPregnant: null,
    isBreastfeeding: null,
    hasChronicDisease: null,
    chronicDiseaseName: "",
    isVegan: null,
    isVegetarian: null,
    otherMedicineWithName: "",
  };

  const handleSubmit = (values) => {
    console.log("Form submitted:", values);
    onContinue?.(values);
  };

  return (
    <>
      <h2 className="question-title">Basic Information</h2>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ values }) => {
          const isAllFilled = Object.entries(values).every(([key, val]) => {
            if (key === "chronicDiseaseName" && !values.hasChronicDisease) {
              return true;
            }
            if (val === null || val === undefined) return false;
            if (typeof val === "string") return val.trim() !== "";
            return true;
          });

          return (
            <Form className="form-section">
              {/* Date of Birth */}
              <CustomInput
                type="date"
                label="Date of Birth"
                name="dateOfBirth"
              />

              {/* Allergies */}
              <CustomInput
                type="text"
                label="Do you have any allergies?"
                name="allergies"
                placeholder="I’m allergic to penicillin and shellfish."
              />

              {/* Pregnancy */}
              <div className="d-flex justify-content-between btn-mobile">
                <CustomInput
                  type="boolean"
                  label="Are you pregnant?"
                  name="isPregnant"
                />

                {/* Breastfeeding */}
                <CustomInput
                  type="boolean"
                  label="Are you breastfeeding?"
                  name="isBreastfeeding"
                />
              </div>

              {/* Chronic Disease */}
              <div className="d-flex justify-content-between btn-mobile">
                <CustomInput
                  type="boolean"
                  label="Are you vegan?"
                  name="isVegan"
                />
                <CustomInput
                  type="boolean"
                  label="Are you vegetarian?"
                  name="isVegetarian"
                />
              </div>
              <CustomInput
                type="boolean"
                label="Any chronic disease"
                name="hasChronicDisease"
              />
              {/* Chronic Disease Name - Show only if Yes is selected */}
              {values.hasChronicDisease && (
                <CustomInput
                  type="text"
                  label="Name the chronic disease"
                  name="chronicDiseaseName"
                  placeholder="Hypothyroidism"
                />
              )}

              {/* Other Medicine */}
              <CustomInput
                type="text"
                label=" Are you taking any other medicine or supplement?"
                name="otherMedicineWithName"
                placeholder="Yes — Thyronorm, Vitamin D3, and Ashwagandha."
              />

              <button
                type="submit"
                className={`continue-btn ${
                  isAllFilled ? "active" : "disabled"
                }`}
                disabled={!isAllFilled}
              >
                Continue
              </button>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default BasicInfo;
